export default __webpack_public_path__ + "static/media/aiFT.4b5b0e8c.svg";